import React from 'react';
import { motion } from 'framer-motion';
import { staggerContainer } from '../utils/animations';
import { useTheme, getThemeColors } from '../contexts/ThemeContext';

const Section = React.forwardRef(({ 
  children, 
  className = '', 
  id,
  background = 'default',
  containerSize = 'default',
  animate = true,
  ...props 
}, ref) => {
  const { isDarkMode } = useTheme();
  const colors = getThemeColors(isDarkMode);
  
  const backgrounds = {
    default: isDarkMode ? 'bg-black' : 'bg-white',
    dark: isDarkMode ? 'bg-neutral-950' : 'bg-neutral-50',
    texture: isDarkMode ? 'bg-black steel-texture' : 'bg-white steel-texture',
    particles: isDarkMode ? 'bg-black particle-field relative' : 'bg-white particle-field relative',
    gradient: isDarkMode ? 'bg-gradient-to-b from-black to-neutral-900' : 'bg-gradient-to-b from-white to-neutral-100'
  };
  
  const containers = {
    default: 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8',
    wide: 'max-w-8xl mx-auto px-4 sm:px-6 lg:px-8',
    full: 'w-full px-4 sm:px-6 lg:px-8',
    narrow: 'max-w-4xl mx-auto px-4 sm:px-6 lg:px-8'
  };
  
  const sectionClasses = `relative py-16 lg:py-24 ${backgrounds[background]} transition-colors duration-300 ${className}`;
  
  return (
    <section 
      ref={ref}
      id={id}
      className={sectionClasses}
      {...props}
    >
      <motion.div 
        className={containers[containerSize]}
        variants={animate ? staggerContainer : undefined}
        initial="initial"
        whileInView="animate"
        viewport={{ once: true, amount: 0.3 }}
      >
        {children}
      </motion.div>
    </section>
  );
});

Section.displayName = 'Section';

export default Section;